import { api } from './api'

function assertSuccess(body) {
  if (!body?.success) {
    const err = new Error(body?.message || 'Request failed')
    err.code = body?.error?.code
    throw err
  }
  return body.data
}

function apiError(err) {
  const msg = err.response?.data?.message || err.message || 'Request failed'
  const next = new Error(msg)
  next.code = err.response?.data?.error?.code
  next.status = err.response?.status
  return next
}

function orgHeader(organisationId) {
  const id = organisationId != null && organisationId !== '' ? String(organisationId) : ''
  if (!id) throw new Error('Organisation id required')
  return { 'X-Organisation-Id': id }
}

export const storesApi = {
  /**
   * List stores for an organisation (super_admin + X-Organisation-Id).
   * @returns {Promise<{ items: unknown[] }>}
   */
  async list(organisationId) {
    try {
      const { data } = await api.get('/stores', {
        headers: orgHeader(organisationId),
      })
      const payload = assertSuccess(data)
      return payload?.items != null ? payload : { items: [] }
    } catch (e) {
      throw apiError(e)
    }
  },

  /**
   * Update a store scoped to organisation.
   */
  async update(organisationId, storeId, body) {
    try {
      const { data } = await api.patch(`/stores/${encodeURIComponent(storeId)}`, body, {
        headers: orgHeader(organisationId),
      })
      return assertSuccess(data)
    } catch (e) {
      throw apiError(e)
    }
  },

  /**
   * Create a store for an organisation (super_admin + X-Organisation-Id).
   */
  async create(organisationId, body: {
    name: string
    subdomain: string
    currency?: string
    contactEmail?: string
    contactPhone?: string
    sellingSummary?: string
  }) {
    try {
      const { data } = await api.post('/stores', body, {
        headers: orgHeader(organisationId),
      })
      return assertSuccess(data)
    } catch (e) {
      throw apiError(e)
    }
  },
}
